export const APP_VERSION = "v1.1.0";
export const APP_NAME = "Finaculator Console";
export const BUILD_DATE = "2026-07-27";

export const getAppVersionString = () => `${APP_NAME} ${APP_VERSION}`;
